import { TaskAltRounded } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack } from 'components/ui';
import {
  ACTIVATE_ERROR_TITLE,
  ACTIVATE_SUCCESS_TITLE,
  ACTIVATE_UNKNOWN_STATE_MESSAGE,
} from 'pages/Auth/ActivateAccount/ActivateAccount.constants';
import { RESEND_ACTIVATION_SUBMIT_LABEL } from 'pages/Auth/ActivateAccount/ResendActivation';
import {
  AuthErrorPanel,
  AuthSignInFooterPrompt,
  AuthSignInRedirectText,
  AuthSuccessPanel,
} from 'pages/Auth/components';
import type { ActivateAccountStatusStepProps } from './ActivateAccountStatusStep.props';

const ActivateAccountStatusStep = ({
  countdown,
  contactAction,
  message,
  resendActivationHref,
  signInHref,
}: ActivateAccountStatusStepProps) => {
  const isSuccess = message?.severity === 'success';
  const successDescription = isSuccess && typeof countdown === 'number'
    ? <AuthSignInRedirectText countdown={countdown} />
    : (message?.text ?? ACTIVATE_UNKNOWN_STATE_MESSAGE);

  return (
    isSuccess ? (
      <AuthSuccessPanel
        description={successDescription}
        extraAction={(
          <Stack alignItems="center" spacing={3}>
            {contactAction}
            {signInHref ? (
              <AuthSignInFooterPrompt replace to={signInHref} />
            ) : null}
          </Stack>
        )}
        icon={<TaskAltRounded fontSize="large" />}
        title={ACTIVATE_SUCCESS_TITLE}
      />
    ) : (
      <AuthErrorPanel
        description={successDescription}
        extraAction={
          signInHref ? (
            <AuthSignInFooterPrompt replace to={signInHref} />
          ) : contactAction
        }
        mainAction={
          resendActivationHref ? (
            <Button<typeof RouterLink>
              component={RouterLink}
              replace
              to={resendActivationHref}
              variant="outlined"
              visualVariant="primaryOutline"
            >
              {RESEND_ACTIVATION_SUBMIT_LABEL}
            </Button>
          ) : undefined
        }
        title={ACTIVATE_ERROR_TITLE}
      />
    )
  );
};

export default ActivateAccountStatusStep;
